import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import MyReactComponent from './MyReactComponent';

const containerElementName = 'myReactComponentContainer';
/* https://blog.harveydelaney.com/integrating-react-components-into-an-angular-2-project/ */

@Component({
  selector: 'vb-custom-react',
  template: `<div #${containerElementName} class="custom-coding"></div>
    <div>{{ code }}</div>`,
  styleUrls: ['./custom-react.component.scss', '../../../assets/css/index.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: false  //NOSONAR
})
export class CustomReactComponent implements OnChanges, OnDestroy, AfterViewInit {
  @ViewChild(containerElementName, { static: false }) containerRef: ElementRef;

  @Input() public config: any = {};
  @Output() public getFiles = new EventEmitter<void>();
  componentName = 'MyLLC';
  code: any = '';

  props: any = null;

  ngAfterViewInit(): void {
    this.render();
  }
  ngOnDestroy(): void {
    ReactDOM.unmountComponentAtNode(this.containerRef.nativeElement);
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.render();
  }

  parentCallback(data: any) {
    //console.log(data);
    if (this.getFiles) {
      this.getFiles.emit(data);
    }
  }

  render() {
    if (!this.containerRef) {
      return;
    }

    this.props = {
      callback: this.parentCallback.bind(this),
      files: this.config.files,
      getFiles: this.config.getFiles,
      template: this.config.template
    };
    ReactDOM.render(React.createElement(MyReactComponent, this.props), this.containerRef.nativeElement);
  }

  /**
   * Refer this url for implementation
   * https://github.com/codesandbox/sandpack/blob/main/sandpack-react/src/templates/angular.ts
   */
}
